import React, { useEffect, useState, useRef } from 'react';
import battleship from '../assets/battleship.mp4'
import './portfolio.css';

import "aos/dist/aos.css";
import AOS from "aos";
import { Link } from 'react-router-dom';

export function NDCDashboard(){
  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);

    // Hover Effect
    const inputSvgEffect = useRef(null);
    const buttonRef = useRef(null);
    const [positions, setPositions] = useState([0,0]);
    function svgHoverEffect(event){
      const dist = 0.1

      let y = event.clientY;
      let x = event.clientX;
      let array = inputSvgEffect.current.getBoundingClientRect();
      let left = (array.left+array.right)/2
      let top = (array.top+array.bottom)/2
  
      let input_x
      if((x-left) > 0){
        input_x = dist*Math.log(x-left)
      }else if((x-left) === 0){
        input_x = 0
      }else{
        input_x = -dist*Math.log(Math.abs(x-left))
      }
  
      let input_y
      if((y-top) > 0){
        input_y = dist*Math.log(y-top)
      }else if((y-top) === 0){
        input_y = 0
      }else{
        input_y = -dist*Math.log(Math.abs(y-top))
      }
  
      setPositions([input_x,input_y])
    };

  return(
    <div className='introduction-container'>
      <div className='portfolio-body' onMouseMove={svgHoverEffect} ref={buttonRef}>
        <br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>
        <div className='text-portfolio-container'>
          <h1 className='JW-portfolio-title' data-aos='fade-down' role='main'>NDC Data Dashboard</h1><br/>
          <div className='JW-portfolio-text' data-aos='fade-up'>
            <svg viewBox='0 -12 20 12' ref={inputSvgEffect} data-aos='flip-left'>
              <defs>
                <pattern id="svg-pattern" x="0" y="0" width="21" height="21" patternUnits="userSpaceOnUse" patternTransform="translate(11, 11) rotate(15) skewX(0) scale(0.01)">
                  <svg width="10" height="10" viewBox="0 0 20 20">
                    <g fill="var(--purplishBlue)" opacity="1">
                      <circle cx="10" cy="10" r="10"></circle>
                    </g>
                  </svg>
                </pattern>
              </defs>
              <path fill='var(--transBlue)' transform={'translate('+positions[0]+' '+positions[1]+') scale(0.95,0.95)'} strokeWidth='0' d='M 2 0 L 9 0 L 9 -10 C 9 -11, 8 -11, 8 -11 L 3 -11 C 3 -11, 2 -11, 2 -10 Z' />
              <path fill='url(#svg-pattern)' transform={'translate('+positions[0]+' '+positions[1]+') scale(0.95,0.95)'} strokeWidth='0' d='M 11 0 L 18 0 L 18 -6 C 18 -7, 17 -7, 17 -7 L 12 -7 C 12 -7, 11 -7, 11 -6 Z'></path>
              <path fill='transparent' stroke='var(--purplishBlue)' strokeWidth='0.1px' d='M 0 0 L 20 0 L 0 0 Z M 2 0 L 9 0 L 9 -10 C 9 -11, 8 -11, 8 -11 L 3 -11 C 3 -11, 2 -11, 2 -10 Z M 11 0 L 18 0 L 18 -6 C 18 -7, 17 -7, 17 -7 L 12 -7 C 12 -7, 11 -7, 11 -6 Z'/>
            </svg><br/><br/><br/><br/>
            As a lead technical architect and data scientist for the National Deaf Center on Postsecondary Outcomes (NDC), 
            I engineered advanced statistical pipelines and interactive data visualizations to enhance educational and 
            employment success for deaf individuals nationwide. I spearheaded the complete modernization of NDC's data infrastructure, 
            transitioning historical data operations away from manual workflows into automated, high-availability web systems.
            <br/><br/>
            <b className='theB'>Objective</b><br/>
            Modernize NDC's widely cited research portfolio by transforming static PDF reports into an accessible, 
            production-ready data dashboard. The solution required processing over 20GB of weighted microdata, automating 
            the programmatic generation of state-level reporting, and establishing an easily updatable long-term pipeline.
            <br/><br/>
            <b className='theB'>The Challenge</b>
            <ul aria-label='List of challenges'>
              <li>
                <b>Legacy Modernization:</b> Migrating an extensive catalog of static PDF reports (including a flagship 2019 report cited 200+ times) into a dynamic, filterable digital dashboard.
              </li>
              <li>
                <b>Resource Constraints:</b> Developing an ultra-lean, cost-effective infrastructure capable of handling high-profile, nation-wide traffic spikes smoothly.
              </li>
              <li>
                <b>Strict Accessibility:</b> Ensuring perfect UI/UX execution, compliance with accessibility standards, and low-latency performance in a memory-constrained server environment.
              </li>
            </ul>
            
            <b className='theB'>The Solution</b>
            <ul aria-label='List of solutions'>
              <li>
                <b>Full-Stack Architecture:</b> Designed an R-based data processing engine coupled with an Express.js/Node.js backend and a dynamic React.js frontend. Implemented automated CI/CD via GitHub Actions and deployed on Cloudways, maintaining a highly optimized server footprint costing just $28 monthly.
              </li>
              <li>
                <b>Advanced Analytics Engine:</b> Engineered custom statistical pipelines using Monte Carlo simulations, direct standard error computations, and weighted survey design algorithms to handle complex national microdata datasets flawlessly.
              </li>
              <li>
                <b>Programmatic Automation:</b> Scripted a backend sub-system to automatically generate, style, and compile 50 individual state-by-state reports, turning a multi-week manual publishing process into an instantaneous routine.
              </li>
            </ul>
            
            <b className='theB'>The Results</b>
            <ul aria-label='List of results'>
              <li>
                <b>High-Scale Engagement:</b> The dashboard achieved 15,000+ distinct analytical queries within a short window, quickly scaling to become NDC’s most visited digital asset.
              </li>
              <li>
                <b>Zero-Maintenance Scalability:</b> Successfully operationalized the data pipeline for four consecutive annual data refreshes with minimal engineering intervention, consistently serving automated updates across national and state metrics.
              </li>
              <li>
                <b>Institutional & Funding Impact:</b> Served as a critical asset in helping secure over $2 Million in institutional grant funding, gaining widespread organizational adoption by elite bodies including Gallaudet University and the National Association of the Deaf.
              </li>
            </ul><br/><br/>
            <Link
              className='LinkButton'
              to='https://nationaldeafcenter.org/dashboard'
              target='_blank'
              rel="noopener noreferrer"
              aria-label='Link to NDC Dashboard'
              data-aos='zoom-in-up'
            >
              <span className='LinkButton_text JW-patterns'>Explore Dashboard</span>
              <span className='drop-background' style={{transform: 'translate('+positions[0]+'px,'+positions[1]+'px)'}}>Explore Dashboard</span>
            </Link>
          </div>      
        </div>
      </div>
    </div>
  )
}

export function ParkinsonDisease(){
  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);

    // Hover Effect
    const inputSvgEffect = useRef(null);
    const buttonRef = useRef(null);
    const [positions, setPositions] = useState([0,0]);
    function svgHoverEffect(event){
      const dist = 0.1

      let y = event.clientY;
      let x = event.clientX;
      let array = inputSvgEffect.current.getBoundingClientRect();
      let left = (array.left+array.right)/2
      let top = (array.top+array.bottom)/2
  
      let input_x
      if((x-left) > 0){
        input_x = dist*Math.log(x-left)
      }else if((x-left) === 0){
        input_x = 0
      }else{
        input_x = -dist*Math.log(Math.abs(x-left))
      }
  
      let input_y
      if((y-top) > 0){
        input_y = dist*Math.log(y-top)
      }else if((y-top) === 0){
        input_y = 0
      }else{
        input_y = -dist*Math.log(Math.abs(y-top))
      }
  
      setPositions([input_x,input_y])
    };

  return(
    <div className='introduction-container'>
      <div className='portfolio-body' onMouseMove={svgHoverEffect} ref={buttonRef}>
        <br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>
        <div className='text-portfolio-container'>
          <h1 className='JW-portfolio-title' data-aos='fade-down' role='main'>Parkinson's & Depression Causal Inference</h1><br/>
          <div className='JW-portfolio-text' data-aos='fade-up'>
            <svg viewBox='0 -12 20 12' ref={inputSvgEffect} data-aos='flip-left'>
              <defs>
                <pattern id="svg-pattern" x="0" y="0" width="21" height="21" patternUnits="userSpaceOnUse" patternTransform="translate(11, 11) rotate(15) skewX(0) scale(0.01)">
                  <svg width="10" height="10" viewBox="0 0 20 20">
                    <g fill="var(--purplishBlue)" opacity="1">
                      <circle cx="10" cy="10" r="10"></circle>
                    </g>
                  </svg>
                </pattern>
              </defs>
              <path fill='var(--transBlue)' transform={'translate('+positions[0]+' '+positions[1]+') scale(0.95,0.95)'} strokeWidth='0' d='M 8 -3.5 A 1 1 0 0 0 13 -3.5 A 1 1 0 0 0 8 -3.5 Z' />
              <path fill='var(--transBlue)' transform={'translate('+positions[0]+' '+positions[1]+') scale(0.95,0.95)'} strokeWidth='0' d='M 12 -8.7 A 1 1 0 0 0 17 -8.7 A 1 1 0 0 0 12 -8.7 Z' />
              <path fill='url(#svg-pattern)' transform={'translate('+positions[0]+' '+positions[1]+') scale(0.95,0.95)'} strokeWidth='0' d='M 3 -8.5 A 1 1 0 0 0 8 -8.5 A 1 1 0 0 0 3 -8.5 Z'></path>
              <path fill='transparent' stroke='var(--purplishBlue)' strokeWidth='0.1px' d='M 3 -8.5 A 1 1 0 0 0 8 -8.5 A 1 1 0 0 0 3 -8.5 Z M 8 -3.5 A 1 1 0 0 0 13 -3.5 A 1 1 0 0 0 8 -3.5 Z M 12 -8.7 A 1 1 0 0 0 17 -8.7 A 1 1 0 0 0 12 -8.7 Z M 5.5 -6 L 8.05 -4 L 5.5 -6 Z M 12.95 -4 L 14.5 -6.2 L 12.95 -4 Z M 8 -8.5 L 12 -8.7 L 8 -8.5 Z'/>
            </svg><br/><br/><br/><br/>
            As a lead consulting statistician at the Rochester Institute of Technology (RIT), I directed advanced methodological 
            and statistical engagements for over 10 cross-disciplinary professors, directors, and researchers. Utilizing Python, R, and SPSS, 
            I spearheaded a complex clinical research initiative investigating the structural causal-effect relationships between 
            Parkinson's disease (PD) and comorbid depression severity.
            <br/><br/>
            <b className='theB'>Objective</b><br/>
            Quantify the directional causal mechanisms linking Parkinson's disease with depression severity, isolate the interplay 
            between motor and non-motor symptoms (NMS), and construct a mathematically rigorous causal framework to analyze latent patient outcomes.
            <br/><br/>
            <b className='theB'>The Challenge</b>
            <ul aria-label='List of challenges'>
              <li>
                <b>Latent Construct Measurement:</b> Depression cannot be directly observed; measuring its exact severity required navigating severe item-level overlap, variable severity, and systemic measurement error.
              </li>
              <li>
                <b>Absence of Causal Baselines:</b> Unlike Alzheimer's disease, no gold-standard Directed Acyclic Graph (DAG) exists in medical literature for Parkinson's pathology, creating complex unmeasured confounding risks.
              </li>
            </ul>
            
            <b className='theB'>The Approach</b>
            <ul aria-label='List of approaches'>
              <li>
                <b>Causal Graph Engineering:</b> Partnered with clinical subject-matter experts to map theoretical *a priori* medical knowledge into an explicit Directed Acyclic Graph (DAG) to isolate back-door paths and control for confounders.
              </li>
              <li>
                <b>Psychometric Modeling (IRT & SEM):</b> Deployed a 2-Parameter Logistic (2-PL) Item Response Theory model unified within a Structural Equation Modeling (SEM) architecture. Integrated Differential Item Functioning (DIF) to ensure measurement invariance across patient sub-populations.
              </li>
              <li>
                <b>Econometric Estimation:</b> Applied a Tobit regression framework conditioned on the DAG structure and factor scores generated by the 2-PL model. Estimated true causal impacts using Average Treatment Effects (ATE) to handle censored outcome distributions.
              </li>
            </ul>
            
            <b className='theB'>The Results</b>
              <ul aria-label='List of results'>
              <li>
                <b>Clinical Insights on Latent Severity:</b> Empirically demonstrated that comorbid depression exerts a disproportionately higher severity burden on individuals with PD relative to non-PD control groups—a vital finding given that 30-40% of PD patients exhibit non-motor symptoms.
              </li>
              <li>
                <b>Item-Level Diagnostics:</b> DIF analysis isolated *"Dropped interests and activities"* as the single strongest clinical indicator of acute depression severity among the sample cohort.
              </li>
              <li>
                <b>Actionable Therapeutic Findings:</b> Causal ATE estimation verified a statistically significant negative association between ambulatory physical activity and depression, confirming that increases in daily walking hours directly cause a drop in depression severity.
              </li>
              <li>
                <b>Algorithmic Next Steps:</b> Laid the architectural groundwork for verifying the DAG structure using automated data-driven causal discovery algorithms, specifically Fast Greedy Equivalence Search (FGES) and Fast Causal Inference (FCI).
              </li>
            </ul><br/><br/>
            <Link
              className='LinkButton'
              to='https://doi.org/10.1101/2024.05.29.24308144'
              target='_blank'
              rel="noopener noreferrer"
              aria-label="Link to Parkinson's research paper"
              data-aos='zoom-in-up'
            >
              <span className='LinkButton_text JW-patterns'>Read Research Paper</span>
              <span className='drop-background' style={{transform: 'translate('+positions[0]+'px,'+positions[1]+'px)'}}>Read Research Paper</span>
            </Link>
          </div>      
        </div>
      </div>
    </div>
)
}

export function Battleship(){
  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);

  // Hover Effect
  const inputSvgEffect = useRef(null);
  const buttonRef = useRef(null);
  const [positions, setPositions] = useState([0,0]);
  function svgHoverEffect(event){
      const dist = 0.1

      let y = event.clientY;
      let x = event.clientX;
      let array = inputSvgEffect.current.getBoundingClientRect();
      let left = (array.left+array.right)/2
      let top = (array.top+array.bottom)/2
  
      let input_x
      if((x-left) > 0){
        input_x = dist*Math.log(x-left)
      }else if((x-left) === 0){
        input_x = 0
      }else{
        input_x = -dist*Math.log(Math.abs(x-left))
      }
  
      let input_y
      if((y-top) > 0){
        input_y = dist*Math.log(y-top)
      }else if((y-top) === 0){
        input_y = 0
      }else{
        input_y = -dist*Math.log(Math.abs(y-top))
      }
  
      setPositions([input_x,input_y])
  };

  return(
    <div className='introduction-container'>
      <div className='portfolio-body' onMouseMove={svgHoverEffect} ref={buttonRef}>
        <br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>
        <div className='text-portfolio-container'>
          <h1 className='JW-portfolio-title' data-aos='fade-down' role='main'>Fingerspelling Battleship</h1><br/>
          <div className='JW-portfolio-text' data-aos='fade-up'>
            <svg viewBox='0 -11.5 20 12.5' ref={inputSvgEffect} data-aos='flip-left'>
              <defs>
                <pattern id="svg-pattern" x="0" y="0" width="21" height="21" patternUnits="userSpaceOnUse" patternTransform="translate(11, 11) rotate(15) skewX(0) scale(0.01)">
                  <svg width="10" height="10" viewBox="0 0 20 20">
                    <g fill="var(--purplishBlue)" opacity="1">
                      <circle cx="10" cy="10" r="10">
                      </circle>
                    </g>
                  </svg>
                </pattern>
              </defs>
              <path fill='var(--transBlue)' transform={'translate('+positions[0]+' '+positions[1]+') scale(0.95,0.95)'} strokeWidth='0' d='M 8.5 -2 Q 8 -2 8 -1.5 L 8 -0.5 Q 8 0 8.5 0 L 11.5 0 Q 12 0 12 -0.5 L 12 -1.5 Q 12 -2 11.5 -2 Z' />
              <path fill='url(#svg-pattern)' transform={'translate('+positions[0]+' '+positions[1]+') scale(0.95,0.95)'} strokeWidth='0' d='M 12.6912 -9.109 c -0.3119 -0.0634 -0.6171 0.1377 -0.6809 0.45 l -0.2748 1.3459 c -0.0103 0.0507 -0.0584 0.0845 -0.1096 0.0771 c -0.0512 -0.0074 -0.0878 -0.0533 -0.0833 -0.1049 l 0.2086 -2.4501 c 0.0297 -0.349 -0.2292 -0.6562 -0.5782 -0.6858 c -0.3488 -0.0297 -0.6562 0.2292 -0.6858 0.5782 l -0.1777 2.0866 c -0.0046 0.0547 -0.0515 0.0959 -0.1065 0.0936 c -0.0547 -0.0023 -0.0981 -0.0474 -0.0981 -0.1023 V -10.3725 C 10.1049 -10.7229 9.8208 -11.0069 9.4705 -11.0069 s -0.6344 0.284 -0.6344 0.6344 v 2.5116 c 0 0.045 -0.035 0.0821 -0.0798 0.0846 c -0.0449 0.0026 -0.0839 -0.0302 -0.0892 -0.0748 l -0.2403 -2.039 c -0.041 -0.3479 -0.3563 -0.5968 -0.7043 -0.5558 c -0.3479 0.041 -0.5967 0.3563 -0.5558 0.7043 L 7.6622 -5.538 c 0.0064 0.0542 -0.0225 0.1064 -0.0718 0.1297 c -0.0492 0.0233 -0.1081 0.0126 -0.1458 -0.0268 l -1.0606 -1.1016 c -0.2429 -0.2524 -0.6445 -0.26 -0.8969 -0.017 c -0.2524 0.2429 -0.26 0.6445 -0.017 0.8969 l 2.5168 2.6141 c 0.2903 0.3812 0.7488 0.6281 1.264 0.6281 h 1.5212 c 0.9264 0 1.68 -0.7537 1.68 -1.68 c 0 -0.6366 0.0642 -1.2716 0.1915 -1.8953 l 0.4978 -2.4381 C 13.2049 -8.7405 13.0034 -9.0453 12.6912 -9.109 z'></path>
              <path fill='transparent' stroke='var(--purplishBlue)' strokeWidth='0.1px' d='M 12.6912 -9.109 c -0.3119 -0.0634 -0.6171 0.1377 -0.6809 0.45 l -0.2748 1.3459 c -0.0103 0.0507 -0.0584 0.0845 -0.1096 0.0771 c -0.0512 -0.0074 -0.0878 -0.0533 -0.0833 -0.1049 l 0.2086 -2.4501 c 0.0297 -0.349 -0.2292 -0.6562 -0.5782 -0.6858 c -0.3488 -0.0297 -0.6562 0.2292 -0.6858 0.5782 l -0.1777 2.0866 c -0.0046 0.0547 -0.0515 0.0959 -0.1065 0.0936 c -0.0547 -0.0023 -0.0981 -0.0474 -0.0981 -0.1023 V -10.3725 C 10.1049 -10.7229 9.8208 -11.0069 9.4705 -11.0069 s -0.6344 0.284 -0.6344 0.6344 v 2.5116 c 0 0.045 -0.035 0.0821 -0.0798 0.0846 c -0.0449 0.0026 -0.0839 -0.0302 -0.0892 -0.0748 l -0.2403 -2.039 c -0.041 -0.3479 -0.3563 -0.5968 -0.7043 -0.5558 c -0.3479 0.041 -0.5967 0.3563 -0.5558 0.7043 L 7.6622 -5.538 c 0.0064 0.0542 -0.0225 0.1064 -0.0718 0.1297 c -0.0492 0.0233 -0.1081 0.0126 -0.1458 -0.0268 l -1.0606 -1.1016 c -0.2429 -0.2524 -0.6445 -0.26 -0.8969 -0.017 c -0.2524 0.2429 -0.26 0.6445 -0.017 0.8969 l 2.5168 2.6141 c 0.2903 0.3812 0.7488 0.6281 1.264 0.6281 h 1.5212 c 0.9264 0 1.68 -0.7537 1.68 -1.68 c 0 -0.6366 0.0642 -1.2716 0.1915 -1.8953 l 0.4978 -2.4381 C 13.2049 -8.7405 13.0034 -9.0453 12.6912 -9.109 z M 8.5 -2 Q 8 -2 8 -1.5 L 8 -0.5 Q 8 0 8.5 0 L 11.5 0 Q 12 0 12 -0.5 L 12 -1.5 Q 12 -2 11.5 -2 Z'/>
            </svg><br/><br/><br/><br/>
            As a full-stack developer and associate data analyst at Gallaudet University, I architected high-fidelity artificial 
            intelligence datasets and interactive web applications. Navigating complex cloud ecosystems and real-time network protocols, 
            I engineered advanced deep learning data pipelines, conducted cost-benefit evaluations, and conceptualized gamified 
            crowdsourcing engines—exemplified by *Fingerspelling Battleship*.
            <br/><br/>
            <b className='theB'>App Demo</b>
            <video className='JW-video-portfolio' src={battleship} autoPlay loop controls/><br/><br/>
            <b className='theB'>Objective</b><br/>
            Scale Gallaudet's world-class linguistic dataset by programmatically collecting naturalistic, modern American Sign Language 
            (ASL) fingerspelling. The initiative aimed to establish a continuous pipeline for modern colloquial signs, keeping 
            downstream computer vision algorithms resilient to evolving language patterns.
            <br/><br/>
            <b className='theB'>The Challenge</b>
            <ul aria-label='List of challenges'>
              <li>
                <b>Participant Fatigue:</b> Traditional clinical research methods and static data surveys yield steadily declining retention rates, stalling high-volume data-gathering routines due to zero player incentive.
              </li>
              <li>
                <b>Artificial Behavior (Gamesmanship):</b> Gamifying data capture risks introducing performative and exaggerated actions that deviate from organic, real-world movements, threatening to contaminate model validation sets.
              </li>
              <li>
                <b>Resource-Intensive Preprocessing:</b> Sifting through thousands of unverified crowdsourced video frames manually for data hygiene is an impossible operational bottleneck for lean research teams.
              </li>
            </ul>
            
            <b className='theB'>The Approach</b>
            <ul aria-label='List of approaches'>
              <li>
                <b>Real-Time Full-Stack Architecture:</b> Engineered a real-time multiplayer application utilizing an Express.js and Node.js backend linked to a dynamic React.js frontend. Established state synchronization via Socket.io, containerized using Docker, and deployed a self-healing cluster on AWS Elastic Beanstalk capped at a budget-friendly $40 monthly.
              </li>
              <li>
                <b>Algorithmic Quality Filtering:</b> Developed an automated video segmentation script combined with computer vision class validators to programmatically evaluate hand positions, verifying biometric integrity directly inside the data layer. Evaluated human-in-the-loop interactions using a randomized controlled Wizard-of-Oz experimental framework.
              </li>
              <li>
                <b>Secure Ingestion Pipeline:</b> Implemented secure user tracking via Okta identity management using cryptographic, consent-mapped UUIDs. Designed a zero-touch pipeline that transparently structured and streamed raw MP4 files alongside dense rich telemetry (device profiles, session durations, and coarse geolocations) into isolated AWS S3 buckets.
              </li>
            </ul>
            
            <b className='theB'>The Results</b>
            <ul aria-label='List of results'>
              <li>
                <b>Edge-Optimized Data Capture:</b> Achieved reliable, low-latency video and telemetry tracking in real-time without introducing UI execution stutter, protecting both raw video capture quality and core gameplay loop mechanics.
              </li>
              <li>
                <b>Automated Data Enrichment:</b> Successfully established a zero-touch pipeline that pairs raw crowd recordings directly with unified metadata schemas in AWS S3, instantly making the data available for deep learning training queues.
              </li>
              <li>
                <b>Scalable Distributed Orchestration:</b> Engineered robust server-side state machines to handle concurrent multiplayer sessions, incorporating aggressive idle timeouts, distributed queue matchmaking, and soft connection drop protections to handle traffic variation gracefully.
              </li>
            </ul>
            <br/>
            <p style={{fontStyle: 'italic', opacity: 0.8}}>
              Note: Following a successful technical proof-of-concept and alpha implementation, 
              further data collection was paused due to shifts in federal research funding priorities. 
              The core architecture remains a benchmark for gamified, low-cost computer vision data ingestion.
            </p>
          </div>      
        </div>
      </div>
    </div>
  )
}

export function SecureHealthcareApp(){
  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);

  // Hover Effect
  const inputSvgEffect = useRef(null);
  const buttonRef = useRef(null);
  const [positions, setPositions] = useState([0,0]);
  function svgHoverEffect(event){
    const dist = 0.1

    let y = event.clientY;
    let x = event.clientX;
    let array = inputSvgEffect.current.getBoundingClientRect();
    let left = (array.left+array.right)/2
    let top = (array.top+array.bottom)/2
  
    let input_x
    if((x-left) > 0){
      input_x = dist*Math.log(x-left)
    }else if((x-left) === 0){
      input_x = 0
    }else{
      input_x = -dist*Math.log(Math.abs(x-left))
    }
  
    let input_y
    if((y-top) > 0){
      input_y = dist*Math.log(y-top)
    }else if((y-top) === 0){
      input_y = 0
    }else{
      input_y = -dist*Math.log(Math.abs(y-top))
    }
  
    setPositions([input_x,input_y])
  };

  return(
    <div className='introduction-container'>
      <div className='portfolio-body' onMouseMove={svgHoverEffect} ref={buttonRef}>
        <br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>
        <div className='text-portfolio-container'>
          <h1 className='JW-portfolio-title' data-aos='fade-down' role='main'>Healthcare Application</h1><br/>
          <div className='JW-portfolio-text' data-aos='fade-up'>
            <svg viewBox='0 -12 20 12' ref={inputSvgEffect} data-aos='flip-left'>
              <defs>
                <pattern id="svg-pattern" x="0" y="0" width="21" height="21" patternUnits="userSpaceOnUse" patternTransform="translate(11, 11) rotate(15) skewX(0) scale(0.01)">
                  <svg width="10" height="10" viewBox="0 0 20 20">
                    <g fill="var(--purplishBlue)" opacity="1">
                      <circle cx="10" cy="10" r="10"></circle>
                    </g>
                  </svg>
                </pattern>
              </defs>
              {/* Outer Shield - Perfectly scaled inside the ViewBox bounds */}
              <path 
                fill='var(--transBlue)' 
                transform={'translate('+positions[0]+' '+positions[1]+') scale(0.95,0.95)'} 
                strokeWidth='0' 
                d='M 10 -11 L 5 -9.5 L 5 -5.5 C 5 -2.5, 10 -1, 10 -1 C 10 -1, 15 -2.5, 15 -5.5 L 15 -9.5 Z' 
              />
              
              {/* Inner Shield - Proportional inner inlay with pattern fill */}
              <path 
                fill='url(#svg-pattern)' 
                transform={'translate('+positions[0]+' '+positions[1]+') scale(0.95,0.95)'} 
                strokeWidth='0' 
                d='M 10 -9.5 L 6.5 -8.5 L 6.5 -5.5 C 6.5 -3.3, 10 -2.2, 10 -2.2 C 10 -2.2, 13.5 -3.3, 13.5 -5.5 L 13.5 -8.5 Z' 
              />
              
              {/* Wireframe Outline - Razor thin blueprint stroke paths */}
              <path 
                fill='transparent' 
                stroke='var(--purplishBlue)' 
                strokeWidth='0.1px' 
                d='M 10 -11 L 5 -9.5 L 5 -5.5 C 5 -2.5, 10 -1, 10 -1 C 10 -1, 15 -2.5, 15 -5.5 L 15 -9.5 Z M 10 -9.5 L 6.5 -8.5 L 6.5 -5.5 C 6.5 -3.3 10 -2.2 10 -2.2 C 10 -2.2 13.5 -3.3 13.5 -5.5 L 13.5 -8.5 Z'
              />
            </svg><br/><br/><br/><br/>
              As a Research Analyst and Developer at Gallaudet University, I engineered a mission-critical, 
              cross-platform healthcare infrastructure and AI pipeline for a Tier-1 national healthcare network. Operating at the 
              intersection of clinical compliance and real-time computer vision, I architected high-security mobile systems 
              designed to capture and process patient medical history under strict regulatory constraints.
            <br/><br/>
            <b className='theB'>Objective</b><br/>
            Develop and deploy a highly secure, cross-platform mobile app (iOS/iPadOS) to standardize high-integrity data ingestion. 
            The solution required real-time biometric gesture recognition on the edge, automated data pipelines to guide 
            downstream AI training resources, and a zero-trust architecture capable of safeguarding Protected Health Information (PHI).
            <br/><br/>
            <b className='theB'>The Challenge</b>
            <ul aria-label='List of challenges'>
              <li>
                <b>Regulatory Compliance (HIPAA):</b> Handling sensitive clinical data, demographics, and medical history requires absolute adherence to federal HIPAA safeguards, dictating zero persistence of unencrypted PHI on consumer hardware.
              </li>
              <li>
                <b>Edge Compute Restrictions:</b> Executing real-time computer vision models smoothly on mobile device constraints without introducing UI lags or memory leaks, navigating complex CocoaPods autolinking and SDK versioning anomalies.
              </li>
              <li>
                <b>Injection Vulnerabilities:</b> Displaying complex external survey models safely without using standard WebViews, which expose the local application to Cross-Site Scripting (XSS) and injection attacks.
              </li>
            </ul>
            
            <b className='theB'>The Architectural Approach</b>
            <ul aria-label='List of approaches' >
              <li>
                <b>Zero-Persistence & Targeted Wipe:</b> Programmed a native security layer executing a "Targeted Nuclear Wipe" that actively destroys ephemeral session data and memory fragments upon application termination or background state transitions, while cleanly preserving persistent device identities for legal audit auditing.
              </li>
              <li>
                <b>Multi-Factor Cryptography:</b> Implemented administrative access controls utilizing a Two-Factor Verification framework—combining high-entropy password hashing with local iOS biometrics (FaceID/TouchID) alongside an exponential-backoff brute-force lockout safety algorithm.
              </li>
              <li>
                <b>On-Premise Edge AI:</b> Integrated native cross-platform engines with pinned bundles to process real-time hand markpointing and gesture tracking entirely within volatile RAM, dropping external network dependency and data transmission hazards to zero.
              </li>
            </ul>
            
            <b className='theB'>The System Impact</b>
            <ul aria-label='List of impacts'>
              <li>
                <b>Hardened Enterprise Security:</b> Successfully deployed a secure mobile wrapper framework across a Tier-1 healthcare network, ensuring an uncompromisable data footprint for real-world patient tracking.
              </li>
              <li>
                <b>Agnostic On-Premise Execution:</b> Isolated all third-party integrations to local processing contexts, verifying that no clinical metrics, raw footage, or coordinate landmarks are transmitted to external servers.
              </li>
              <li>
                <b>Robust Forensic Integrity:</b> Established an internal database mapping a 6-year rolling legal retention policy, anchoring every system interaction to persistent device asset tags with rigorous transaction checkpoint verification.
              </li>
            </ul>
            <br/>
            <p style={{fontStyle: 'italic', opacity: 0.8}}>
              Note: To maintain institutional compliance and adhere to non-disclosure agreements (NDAs) 
              with the healthcare provider, the underlying repository, brand-specific details, and clinical 
              metrics are strictly confidential.
            </p>
          </div>      
        </div>
      </div>
    </div>
  )
}

export function IngestPipeline(){
  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);

  // Hover Effect
  const inputSvgEffect = useRef(null);
  const buttonRef = useRef(null);
  const [positions, setPositions] = useState([0,0]);
  const [pseudoMouse, setPseudoMouse] = useState([0,0]);
  function svgHoverEffect(event){
    const dist = 0.1

    let mouseX = event.clientX;
    let mouseY = event.clientY;
    let centerX = window.innerWidth/2;
    let centerY = window.innerHeight/2;
    let y = event.clientY;
    let x = event.clientX;
    let pseudoX = 13*mouseX/(centerX*2);
    let pseudoY = 6*mouseY/(centerY*2);
    let array = inputSvgEffect.current.getBoundingClientRect();
    let left = (array.left+array.right)/2
    let top = (array.top+array.bottom)/2
  
    let input_x
    if((x-left) > 0){
      input_x = dist*Math.log(x-left)
    }else if((x-left) === 0){
      input_x = 0
    }else{
      input_x = -dist*Math.log(Math.abs(x-left))
    }
  
    let input_y
    if((y-top) > 0){
      input_y = dist*Math.log(y-top)
    }else if((y-top) === 0){
      input_y = 0
    }else{
      input_y = -dist*Math.log(Math.abs(y-top))
    }
  
    setPositions([input_x,input_y]);
    setPseudoMouse([pseudoX,pseudoY]);
  };

  return(
    <div className='introduction-container'>
      <div className='portfolio-body' onMouseMove={svgHoverEffect} ref={buttonRef}>
        <br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>
        <div className='text-portfolio-container'>
          <h1 className='JW-portfolio-title' data-aos='fade-down' role='main'>Ingestion Pipeline</h1><br/>
          <div className='JW-portfolio-text' data-aos='fade-up'>
            <svg viewBox='-5 -12 27 27' ref={inputSvgEffect} data-aos='fade-down'>
              <defs>
                <pattern id="svg-pattern" x="0" y="0" width="21" height="21" patternUnits="userSpaceOnUse" patternTransform="translate(11, 11) rotate(15) skewX(0) scale(0.01)">
                  <svg width="10" height="10" viewBox="0 0 20 20">
                    <g fill="var(--transDarkerBlue)" opacity="1">
                      <circle cx="10" cy="10" r="10"></circle>
                    </g>
                  </svg>
                </pattern>
              </defs>
              <path fill='url(#svg-pattern)' strokeWidth='0' transform={'translate('+positions[0]+' '+positions[1]+')'} d='M -4 2 A 0.1 0.1 0 0 0 21 2 A 0.1 0.1 0 0 0 -4 2 Z'/>
              <path fill='var(--transBlue)' strokeWidth='0' transform={'translate('+positions[0]+' '+(positions[1]-4)+')'} d='M 13 12 Q 14 12 14 11 L 14 9.6 L -2 9.6 L -2 11 Q -2 12 -1 12 Z M 3.7 14.6 L 3.7 15 L 8.3 15 L 8.3 14.6 L 3.7 14.6 L 4 14.6 L 4 12 L 8 12 L 8 14.6 Z  M -1 2 L 13 2 L 13 9 L -1 9 Z M 5.6 8 Q 6 8 6 7.6 L 6 3.4 L 0 3.4 L 0 7.6 Q 0 8 0.4 8 Z' />
              <path fill='transparent' strokeWidth='0.1' transform='translate(0 -4)' stroke='var(--purplishBlue)' d='M 13 12 Q 14 12 14 11 L 14 2 Q 14 1 13 1 L -1 1 Q -2 1 -2 2 L -2 11 Q -2 12 -1 12 Z M -1 2 L 13 2 L 13 9 L -1 9 Z M 6 10.2 A 0.1 0.1 0 0 0 6 10.9 A 0.1 0.1 0 0 0 6 10.2 Z M 6 10.45 A 0.1 0.1 0 0 0 6 10.65 A 0.01 0.01 0 0 0 6 10.45 Z M 3.7 14.6 L 3.7 15 L 8.3 15 L 8.3 14.6 L 3.7 14.6 L 4 14.6 L 4 12 L 8 12 L 8 14.6 Z M 5.6 8 Q 6 8 6 7.6 L 6 3.4 Q 6 3 5.6 3 L 0.4 3 Q 0 3 0 3.4 L 0 7.6 Q 0 8 0.4 8 Z M 0 3.4 L 6 3.4 L 0 3.4 Z M 2 3.4 L 2 8 L 2 3.4 Z M 0.4 4 L 1.7 4 L 0.4 4 Z M 0.4 4.2 L 1.7 4.2 L 0.4 4.2 Z M 0.4 4.4 L 1.7 4.4 L 0.4 4.4 Z M 0.6 4.6 L 1.7 4.6 L 0.6 4.6 Z M 0.9 4.8 L 1.7 4.8 L 0.9 4.8 Z M 0.4 5 L 1.7 5 L 0.4 5 Z M 0.9 5.2 L 1.7 5.2 L 0.9 5.2 Z M 0.9 5.4 L 1.7 5.4 L 0.9 5.4 Z M 0.9 5.6 L 1.7 5.6 L 0.9 5.6 Z M 0.9 5.8 L 1.7 5.8 L 0.9 5.8 Z M 0.6 6 L 1.7 6 L 0.6 6 Z M 0.6 6.2 L 1.7 6.2 L 0.6 6.2 Z M 0.6 6.4 L 1.7 6.4 L 0.6 6.4 Z M 2.5 3.8 L 5.5 3.8 L 2.5 3.8 Z M 2.3 4 L 4 4 L 2.3 4 Z M 2.5 4.2 L 5.5 4.2 L 2.5 4.2 Z M 2.6 5 L 5.6 5 L 2.6 5 Z M 2.5 5.2 L 5.6 5.2 L 2.5 5.2 Z M 2.4 5.8 L 5.2 5.8 L 2.4 5.8 Z M 2.5 6 L 5.6 6 L 2.5 6 Z M 4.5 6.2 L 5.2 6.2 L 4.5 6.2 Z M 3.5 6.4 L 5.1 6.4 L 3.5 6.4 Z'/>
              <path fill='var(--whitishPurple)' strokeWidth='0' d='M 22 18 L 22 11 L -4 11 L -4 18 Z' />
              <path fill='var(--purplishBlue)' strokeWidth='0' transform={'translate('+pseudoMouse[0]+' '+(pseudoMouse[1]-4)+')'} d='M -0.5 2.5 L -0.1343 2.8297 L -0.3373 2.8654 L -0.4997 2.9924 Z'/>
              <path fill='transparent' strokeWidth='0.1' stroke='var(--purplishBlue)' d='M -7 11 L 25 11 Z' />
            </svg><br/><br/><br/><br/>
            As a Data Scientist at Sign AI, I architected, built, and deployed a high-throughput, multi-threaded 
            media ingestion pipeline designed to process and validate massive video datasets for downstream computer vision models. 
            Faced with severe operational timing constraints, I conceptualized and executed the end-to-end software 
            infrastructure within a rapid, high-velocity two-week development lifecycle.
            <br/><br/>
            <b className='theB'>Objective</b><br/>
            Engineer and deliver a standalone desktop ETL automation system within a tight 14-day window to ingest raw video telemetry and multi-layered metadata. 
            The solution required parsing unstructured local files, applying real-time frame filtering, maintaining a thread-safe UI layout during parallel cloud uploads, and guaranteeing 100% relational database transaction integrity.
            <br/><br/>
            <b className='theB'>The Challenge</b>
            <ul aria-label='List of challenges'>
              <li>
                <b>High-Volume Media Parsing Bottlenecks:</b> Indexing thousands of unmapped disk paths, processing dense contextual schemas, and analyzing video container variables manually caused debilitating I/O blocks under single-threaded paradigms.
              </li>
              <li>
                <b>Asynchronous UI Invalidation:</b> Orchestrating extensive block storage transfers in tandem with transactional database writes frequently stalled the local application window, exposing the system to runtime freezes and user-forced terminations.
              </li>
              <li>
                <b>Host Power Interference:</b> Continuous batch asset streaming over long intervals would repeatedly trigger native operating system idle hooks, forcing target devices into sleep states and compromising mid-flight network operations.
              </li>
            </ul>
            
            <b className='theB'>The Architectural Approach</b>
            <ul aria-label='List of approaches'>
              <li>
                <b>High-Speed Columnar ETL:</b> Leveraged vectorized data processing engines integrated with low-level media probings to map deep file structures instantly. Programmed frame calculations and duration filters to drop data fragments under 2000ms straight out of the ingestion queue.
              </li>
              <li>
                <b>Isolated Worker Concurrency:</b> Structured detached backend worker pools leveraging explicit cross-thread signal emission channels. This decoupled continuous file stream tasks entirely from the main interface runtime loop, sustaining an ultra-smooth, responsive desktop experience.
              </li>
              <li>
                <b>Atomic Logging & Secrets Ingestion:</b> Built an authentication and transfer verification framework communicating dynamically with remote credential management systems. Bound transactional relational inserts into bulk batch execution layers with strict tracking to neutralize schema inconsistencies over unstable networks.
              </li>
              <li>
                <b>OS Sleep Suppression:</b> Wrapped background worker sequences inside an execution-safeguard context manager to natively intercept and override host power management behaviors, ensuring continuous asset streaming while rendering manual cancel hooks to the operator.
              </li>
              <li>
                <b>Deterministic Workspaces:</b> Applied an automation harness (via GNU Make) to handle virtual environment compilation, dependency isolation, and standalone compilation packaging, converting complex manual setups into single-line executable workflows.
              </li>
            </ul>
            
            <b className='theB'>The System Impact</b>
            <ul aria-label='List of impacts'>
              <li>
                <b>Rapid Ingestion Deployment:</b> Designed, tested, and shipped a production-ready data automation tool from zero to completion in under 14 business days, eliminating manual data handling for institutional AI training initiatives.
              </li>
              <li>
                <b>Zero-Freeze Interface Continuity:</b> Achieved stable, multi-threaded task isolation, allowing multi-gigabyte media batches to buffer and sync smoothly without lagging or dropping desktop interactions.
              </li>
              <li>
                <b>Flawless Forensic Integrity:</b> Maintained complete transaction isolation across block storage buckets and structured metadata schemas, validating atomic data alignments upon final execution.
              </li>
              <li>
                <b>Repeatable Developer Workflows:</b> Compressed environmental dependency provisioning and executable build targets into zero-overhead configuration recipes, establishing a highly reliable blueprint for continuous deployment.
              </li>
            </ul>
            <br/>
            <p style={{fontStyle: 'italic', opacity: 0.8}}>
              Note: To maintain institutional compliance and adhere to strict non-disclosure agreements (NDAs), the source repository, specific target databases, and internal infrastructure brandings are completely confidential.
            </p>
          </div>      
        </div>
      </div>
    </div>
)
}

